import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../../../../helpers/reducerRegistry'
import { getScoreRangesPerformance } from '../../../../../../../../common/header/companyInfo/store/thunk'
import { covertPointRange } from '../../../../../../helper'
import { convertRangesPerformance } from '../helper'
import { getScorePerformance } from './thunk'

const initialState = {
  dataRangesPerformance: {},
  rangePerformance: [],
  pointRangesChart: [],
  dataScorePerformance: {
    scoreValue: 0,
    scoreValue_12M: 0,
    scoreValue_24M: 0,
    scoreRangeNameMediumTer: '',
    scoreRangeNameShortTerm: '',
    comments: [],
    modelDescription: '',
  },
  loading: {
    RangesPerformance: false,
    scorePerformance: false,
    download: false,
  },
}

export const slice = createSlice({
  name: 'companyAnalysis/companyProfile/scoreRangesPerformance',
  initialState,
  reducers: {
    resetStore(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
  },
  extraReducers: (builder) => {
    //getScorePerformance
    builder.addCase(getScorePerformance.pending, (state) => {
      state.loading.scorePerformance = true
    })
    builder.addCase(getScorePerformance.fulfilled, (state, action) => {
      state.dataScorePerformance = action.payload
        ? action.payload
        : initialState['dataScorePerformance']
      state.loading.scorePerformance = false
    })
    builder.addCase(getScorePerformance.rejected, (state, action) => {
      state.loading.scorePerformance = action.payload.loading
    })

    //getRangesPerformance
    builder.addCase(getScoreRangesPerformance.pending, (state) => {
      state.loading.RangesPerformance = true
    })
    builder.addCase(getScoreRangesPerformance.fulfilled, (state, action) => {
      state.pointRangesChart = covertPointRange(action.payload)
      state.rangePerformance = action.payload
      state.dataRangesPerformance = action.payload
        ? convertRangesPerformance(action.payload)
        : initialState['dataRangesPerformance']
      state.loading.RangesPerformance = false
    })
    builder.addCase(getScoreRangesPerformance.rejected, (state, action) => {
      state.loading.RangesPerformance = action.payload.loading
    })
  },
})

export const selectRangesPerformance = (state) =>
  state[slice.name].dataRangesPerformance

export const rangesPerformanceRaw = (state) =>
  state[slice.name].rangePerformance

export const selectDataScorePerformance = (type) => (state) => {
  const data = state[slice.name].dataScorePerformance
  return type ? data[type] : data
}

export const pointRangesChartPerformance = (state) =>
  state[slice.name].pointRangesChart
//loading
export const getLoadingRisk = (type) => (state) =>
  type ? state[slice.name].loading[type] : state[slice.name].loading

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
